import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import PrivateRoute from '../components/guards/PrivateRoute'
import PublicRoute from '../components/guards/PublicRoute'
import PermissionGate from '../components/guards/PermissionGate'
import DashboardLayout from '../components/layout/DashboardLayout'
import useAuth from '../hooks/useAuth'
import { getAuthLandingPath } from '../utils/authLanding'
import { privateRoutes } from './routeList'
import NotFoundPage from '../pages/not-found'

const LoginPage = lazy(() => import('../pages/login'))
const ForgotPasswordPage = lazy(() => import('../pages/forgot-password'))
const SetPasswordPage = lazy(() => import('../pages/set-password'))

const RootRedirect = (): React.JSX.Element => {
  const { user } = useAuth()
  return <Navigate to={getAuthLandingPath(user)} replace />
}

const AppRoutes = (): React.JSX.Element => (
  <Routes>
    <Route element={<PublicRoute />}>
      <Route
        path="/login"
        element={
          <Suspense fallback={null}>
            <LoginPage />
          </Suspense>
        }
      />
      <Route
        path="/forgot-password"
        element={
          <Suspense fallback={null}>
            <ForgotPasswordPage />
          </Suspense>
        }
      />
    </Route>

    <Route
      path="/set-password"
      element={
        <Suspense fallback={null}>
          <SetPasswordPage />
        </Suspense>
      }
    />

    <Route element={<PrivateRoute />}>
      <Route element={<DashboardLayout />}>
        {privateRoutes.map(({ path, component: Page, permission }) => (
          <Route
            key={path}
            path={path}
            element={
              <Suspense fallback={null}>
                {permission ? (
                  <PermissionGate
                    permission={permission}
                    fallback={<p>Your user role does not have access to this page.</p>}
                  >
                    <Page />
                  </PermissionGate>
                ) : (
                  <Page />
                )}
              </Suspense>
            }
          />
        ))}
      </Route>
    </Route>

    <Route path="/" element={<RootRedirect />} />
    <Route path="*" element={<NotFoundPage />} />
  </Routes>
)

export default AppRoutes
